/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Manage_Guild_Expressions_HintInputs */



/**
* | output |
* | --- |
* | "Allows members to edit or remove custom emojis, stickers and sounds in this server." |
*
* @param {Leveling_Perm_Manage_Guild_Expressions_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_manage_guild_expressions_hint = /** @type {((inputs?: Leveling_Perm_Manage_Guild_Expressions_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Manage_Guild_Expressions_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позволяет участникам изменять и удалять собственные эмодзи, стикеры и звуки этого сервера.")
	return /** @type {LocalizedString} */ ("Allows members to edit or remove custom emojis, stickers and sounds in this server.")
});